import adresApi from "../../../api/adresApi";
import mergeDeep from "../../../util/mergeDeep.js";
import { orderByPropertyName, orderByPropertyNameDesc } from "../../../util/orderBy.js";
import { showToastrError, showToastrSuccess, showToastrWarning } from "../../../util/toastr";
import * as messages from "../../../constants/ToastrConstants";
import { LandCodes, AdresTypes } from "../../../constants/DomainConstants";

import assign from 'object-assign';
import { generateGuid } from "../../../util/guid";
import AdresHelper from "../../common/AdresHelper";
import * as types from "../../../constants/ComponentConstants";

export default class AdresOverzichtPageHelper {
	constructor(context, redirector) {
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const context = this.context;
		const props = context.props;
		const params = context.props.match.params;
		const ajaxActions = props.ajaxActions;
		const transactieId = params.transactieId;
		const isNew = props.isNew;

		ajaxActions.started();
		context.AdresHelper = new AdresHelper(context);

		adresApi.getAdressenBySportclub(transactieId, isNew)
			.then((response) => {
				ajaxActions.ended();
				this.processModel(response.data, {}, '', false);
			})
			.catch((ex) => {
				ajaxActions.failed();
				if (ex.response.status === 404) {
					showToastrError(messages.MESSAGE_NO_VALID_TRANSACTION_FOUND);
					context.setState({ hasUnsavedChanges: false });
					context.props.setHasUnsavedChanges(false);
					this.redirector.goTo("/federatie/overzicht");
				}
				else {
					context.props.throwException(ex, true);
				}
			});
	}

	processModel(response, validationResults, validationMessageType, hasUnsavedChanges) {
		const context = this.context;
		let errors = validationResults;

		const tabSettings = response.tabSettings;
		context.props.setTabSettings(tabSettings);

		if (response.transactionId)
			context.props.setActiveTransaction(response.transactionId);

		let model = mergeDeep({}, response.model);
		model.adressen = orderByPropertyName(model.adressen, "soortAdres");

		context.setState({
			originalModel: mergeDeep({}, model),
			model: model,
			errors,
			validationMessageType,
			shouldScrollToFirstError: true,
			hasUnsavedChanges: hasUnsavedChanges,
			undoButtonDisabled: true
		});

		context.props.setHasUnsavedChanges(hasUnsavedChanges);
	}

	sortColumn(index, property) {
		const context = this.context;
		const state = context.state;
		let model = mergeDeep({}, state.model);
		let adressen = [...model.adressen.map(x => mergeDeep({}, x))];
		let sortedTable = state.sortedTable;
		sortedTable = sortedTable == index ? null : index;
		model.adressen = sortedTable !== null && sortedTable == index ? orderByPropertyName(adressen, property) : orderByPropertyNameDesc(adressen, property);

		context.setState({
			model,
			sortedTable
		});
	}

	sortTable(index) {
		switch (index) {
			case 1:
				this.sortColumn(index, "straat");
				break;
			case 3:
				this.sortColumn(index, "postcode");
				break;
			case 4:
				this.sortColumn(index, "land");
				break;
			default:
				break;
		}
	}

	deleteAdres(id) {
		const context = this.context;
		const state = this.context.state;
		let model = mergeDeep({}, state.model);
		let adressen = [...model.adressen.map(x => mergeDeep({}, x))];
		let adresToDelete = mergeDeep({}, adressen.find(x => x.id === id));

		//remove it from the list
		adressen = adressen.filter(x => x.id !== id);

		//only repush it if it is known on the server
		if (adresToDelete.isStored) {
			adresToDelete.toDelete = true;
			adressen.push(adresToDelete);
		}

		model = Object.assign(model, { adressen: adressen });

		context.setState({
			model,
			undoButtonDisabled: false,
			hasUnsavedChanges: true
		});

		this.context.state.hasUnsavedChanges === true || context.props.setHasUnsavedChanges(true);
	}

	save() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;
		const params = context.props.match.params;
		const transactieId = params.transactieId;

		let errors = null;
		let model = null;

		const modelToSave = { transactionId: transactieId, model: this.context.state.model };

		ajaxActions.started();
		return adresApi.save(modelToSave).then((response) => {
			ajaxActions.ended();
			let hasUnsavedChanges = this.context.hasUnsavedChanges;
			let validationMessageType;
			if (response.statusText === "OK" && !response.data.hasValidationErrors) {
				if (Object.keys(response.data.validationResults).length !== 0) {
					model = assign({}, response.data.item);
					errors = assign({}, response.data.validationResults);
					showToastrWarning(messages.MESSAGE_VALIDATION_ERRORS);
					showToastrSuccess(messages.MESSAGE_SAVED);
				}
				else {
					model = assign({}, response.data.item, {});
					errors = {};
					showToastrSuccess(messages.MESSAGE_SAVED);
				}
				hasUnsavedChanges = false;
				validationMessageType = types.ValidationMessageTypes.WARNING;
				this.processModel(model, errors, validationMessageType, hasUnsavedChanges);
			} else {
				errors = assign({}, response.data.validationResults);
				model = assign({}, response.data.item, {});
				
				showToastrError(messages.MESSAGE_VALIDATION_ERRORS);
				validationMessageType = types.ValidationMessageTypes.ERROR;
				this.context.setState({
					errors,
					validationMessageType,
					shouldScrollToFirstError: true
				});
			}
		})
			.catch((ex) => {
				ajaxActions.failed();
				if (ex.response.status === 404) {
					showToastrError(messages.MESSAGE_NO_VALID_TRANSACTION_FOUND);
					context.setState({ hasUnsavedChanges: false });
					context.props.setHasUnsavedChanges(false);
					this.redirector.goTo("/federatie/overzicht");
				}
				else {
					context.props.throwException(ex, true);
				}
			});
	}

	onClickEdit(adresId) {
		if (adresId) {
			let adresToEdit = mergeDeep({}, this.context.state.model.adressen.find(x => x.id === adresId));
			this.context.AdresHelper.editAdres(adresToEdit);

			this.context.setState({
				editMode: true,
				editingAdres: adresToEdit
			});
		}
		else {
			this.context.AdresHelper.editNewAdres(() => {
				let model = mergeDeep({}, this.context.state.editingAdres);
				model['tempSoortAdres1'] = false;
				model['tempSoortAdres2'] = true;
				model['tempSoortAdres3'] = false;
				model['isNew'] = true;

				this.context.setState({
					editMode: true,
					editingAdres: model
				});
			});
		}

		this.context.props.disableTopNav();
	}

	validateEditModel(editModel) {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;
		ajaxActions.started();
		return adresApi.validate(editModel).then((response) => {
			ajaxActions.ended();
			let errors = {};
			let result = false;
			if (response.statusText === "OK" && !response.data.hasValidationErrors) {
				if (Object.keys(response.data.validationResults).length !== 0) {
					errors = assign({}, response.data.validationResults);
					showToastrWarning(messages.MESSAGE_VALIDATION_ERRORS);
				}
				else {
					errors = {};
				}
				result = true;
			} else {
				errors = assign({}, response.data.validationResults);
				showToastrError(messages.MESSAGE_VALIDATION_ERRORS);
				result = false;
			}
			this.context.setState({
				errors
			});

			return result;
		})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}

	closeUnsavedChangesAdresEditModal() {
		this.context.setState({ showUnsavedChangesAdresModal: false });
	}

	confirmUnsavedChangesAdresEdit() {
		this.context.setState({ showUnsavedChangesAdresModal: false });
		this.onClickCancel(true);
	}

	closeUnknownAdresModal() {
		this.context.setState({ showUnknownToPartnerModal: false });
	}

	confirmUnknownAdres() {
		this.context.setState({ showUnknownToPartnerModal: false });
		this.onClickSaveEdit(true);
	}

	createBlankAdresToAdd = (editingAdres, soortAdres) => {
		let adresToAdd = mergeDeep({}, editingAdres);
		adresToAdd.id = generateGuid();
		if(soortAdres != AdresTypes.CORRESPONDENTIEADRES)
			adresToAdd['beschrCorrespAdrEnum'] = undefined;
		if(soortAdres != AdresTypes.EXPLOITATIEADRES)
			adresToAdd['beschrExplAdr'] = undefined;

		adresToAdd.soortAdres = soortAdres;
		adresToAdd['tempSoortAdres1'] = undefined;
		adresToAdd['tempSoortAdres2'] = undefined;
		adresToAdd['tempSoortAdres3'] = undefined;
		adresToAdd['isNew'] = false;

		return adresToAdd;
	};

	onClickSaveEdit(unknownConfirmed) {
		const state = this.context.state;
		const model = mergeDeep({}, state.model);
		const adressesToAdd = [];
		const editingAdres = mergeDeep({}, state.editingAdres);

		if (!unknownConfirmed
			&& editingAdres.land === LandCodes.BELGIE
			&& ((!editingAdres.straatId && editingAdres.straat))) {
			// || (!editingAdres.huisnummerId && editingAdres.huisnummer)
			// || (!editingAdres.busnummerId && editingAdres.busnummer))) {
			this.context.setState({ showUnknownToPartnerModal: true });
			return;
		}

		this.validateEditModel(editingAdres).then(success => {
			if (!success)
				return;

			if (editingAdres['tempSoortAdres1'] === true|| editingAdres['tempSoortAdres2'] === true || editingAdres['tempSoortAdres3'] === true) {
				if (editingAdres.tempSoortAdres1)
					adressesToAdd.push(this.createBlankAdresToAdd(editingAdres, AdresTypes.MAATSCHAPPELIJKE_ZETEL));
				if (editingAdres.tempSoortAdres2)
					adressesToAdd.push(this.createBlankAdresToAdd(editingAdres, AdresTypes.CORRESPONDENTIEADRES));
				if (editingAdres.tempSoortAdres3)
					adressesToAdd.push(this.createBlankAdresToAdd(editingAdres, AdresTypes.EXPLOITATIEADRES));
			}
			else
				adressesToAdd.push(editingAdres);

			this.context.state.hasUnsavedChanges === true || this.context.props.setHasUnsavedChanges(this.context.state.hasUnsavedChangesAdresEdit || false);

			const soortenAdresAddedAdresses = adressesToAdd.map(a => a.soortAdres);
			const adressToAdd = adressesToAdd[0];

			if (state.model.adressen.find(a => soortenAdresAddedAdresses.indexOf(a.soortAdres) > -1 && a.land === adressToAdd.land && a.postcode === adressToAdd.postcode && a.straat === adressToAdd.straat 
			&& a.huisnummer === adressToAdd.huisnummer && a.busnummer === adressToAdd.busnummer &&  a.beschrCorrespAdrEnum === adressToAdd.beschrCorrespAdrEnum && a.beschrExplAdr === adressToAdd.beschrExplAdr)) {
				showToastrError("Dit adres is reeds al aangemaakt");
				return;
			}

			model.adressen = orderByPropertyName([...state.model.adressen.filter(x => x.id !== state.editingAdres.id), ...adressesToAdd], "soortAdres");

			this.context.setState({
				editMode: false,
				editingAdres: {},
				gemeenten: [],
				straten: [],
				huisnummers: null, //null means no data retrieved from Partner, empty array means no elements found
				busnummers: null, //null means no data retrieved from Partner, empty array means no elements found
				stratenLoading: false,
				huisnummersLoading: false,
				busnummersLoading: false,
				model: model,
				errors: {},
				hasUnsavedChangesAdresEdit: false,
				hasUnsavedChanges: this.context.state.hasUnsavedChangesAdresEdit || false,
				undoButtonDisabled: this.context.state.hasUnsavedChangesAdresEdit ? false : true
			});


			this.context.props.enableTopNav();
		});
	}

	onClickCancel(unsavedChangesAdresEditConfirmed) {
		if (!unsavedChangesAdresEditConfirmed && this.context.state.hasUnsavedChangesAdresEdit) {
			this.context.setState({ showUnsavedChangesAdresModal: true });
			return;
		}

		this.context.setState({
			editMode: false,
			editingAdres: {},
			gemeenten: [],
			straten: [],
			huisnummers: null, //null means no data retrieved from Partner, empty array means no elements found
			busnummers: null, //null means no data retrieved from Partner, empty array means no elements found
			stratenLoading: false,
			huisnummersLoading: false,
			busnummersLoading: false,
			errors: {},
			hasUnsavedChangesAdresEdit: false,
			hasUnsavedChanges: this.context.state.hasUnsavedChanges || false
		});

		(this.context.state.hasUnsavedChanges === this.context.state.hasUnsavedChangesAdresEdit || this.context.state.hasUnsavedChanges === false) ||
			this.context.props.setHasUnsavedChanges(this.context.state.hasUnsavedChanges || false);

		this.context.props.enableTopNav();
	}

	onChangeAdresField = (event) => {
		const context = this.context;
		const state = context.state;

		const property = event.target.name;
		const value = event.target.value;

		if (context.AdresHelper.changeAdresField(property, value)) {
			context.setState({
				hasUnsavedChangesAdresEdit: true
			});
			return; //no need to continue if change handled by adresHelper
		}

		const model = state.editingAdres;
		if (property === "toonOpKaart") {
			model[property] = event.target.checked;
		}
		else if (property.indexOf('SoortAdres') > -1) {
			model[property] = event.target.checked;
		}
		else {
			model[property] = value;
		}

		const originalModel = state.originalModel.adressen.find(a => a.id === model.id);

		model.isChanged = originalModel ? model[property] !== originalModel[property] : false;

		const soortenAdres = mergeDeep({}, { tempSoortAdres1: model.tempSoortAdres1, tempSoortAdres2: model.tempSoortAdres2, tempSoortAdres3: model.tempSoortAdres3 });
		const meerdereSoortenAdres = Object.values(soortenAdres).filter(x => x === true).length > 1;
		const marker = mergeDeep({}, state.editingMarker);
		marker.color = meerdereSoortenAdres ?
			types.COLOR_PURPLE :
			model.tempSoortAdres1 === true ?
				types.COLOR_GREEN : model.tempSoortAdres2 === true ?
					types.COLOR_BLUE : model.tempSoortAdres3 === true ?
						types.COLOR_RED : types.COLOR_BLACK;
		marker.size = meerdereSoortenAdres ? "xxl" : "";

		context.setState({
			editingAdres: model,
			hasUnsavedChangesAdresEdit: true,
			landHasFocus: false
		});
	};

	loadStraten = (postcode) => {
		const context = this.context;

		if (!postcode) {
			context.setState({ straten: [] });
			return;
		}

		context.setState({ stratenLoading: true });
		adresApi.getStraten(postcode)
			.then((response) => {
				let uniekeStraten = [];
				response.data.forEach(s => {
					if (!uniekeStraten.find(x => x.straatId === s.straatId || x.naam === s.naam))
						uniekeStraten.push(s);
				});
				context.setState({
					stratenLoading: false,
					straten: uniekeStraten.map(e => { return { label: e.naam, value: e.straatId }; })
				});
			})
			.catch((ex) => {
				alert("getStraten Error");
			});
	};

	undo() {
		const context = this.context;
		const state = context.state;
		let model = mergeDeep({}, state.model);

		model = mergeDeep({}, state.originalModel);

		context.setState({
			model,
			undoButtonDisabled: true,
			hasUnsavedChanges: false
		});
		this.context.state.hasUnsavedChanges === false || context.props.setHasUnsavedChanges(false);
	}
}
